'use client';

import { useState } from 'react';

import { LineCloseIcon, LineInfoIcon } from '@/app/_components/icons/line';
import { cn } from '@/app/lib/utils/tailwindcss';

const bulletItemClass = cn(
  'relative pl-2.5 typo-caption-1 text-mini-game-ranking-tooltip-text whitespace-nowrap',
  'before:absolute before:left-0 before:top-0 before:content-[\'·\']',
  'before:font-extrabold before:text-mini-game-ranking-tooltip-text',
);

export default function Tooltip() {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const openTooltip = () => {
    setIsTooltipOpen(true);
  };

  const closeTooltip = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsTooltipOpen(false);
  };

  return (
    <div
      className="absolute left-[calc(50%+46px)] top-1 z-7 cursor-pointer"
      onClick={openTooltip}
    >
      <LineInfoIcon size={16} color="var(--color-mini-game-ranking-info-icon)" />

      {isTooltipOpen && (
        <div
          className={cn(
            // Position & Size
            'absolute left-[-189px] top-[31px]',
            // Layout
            'flex gap-1',
            // Style
            'rounded-lg bg-mini-game-ranking-tooltip-bg px-3 py-2',
            // Arrow (pseudo-element)
            'after:absolute after:right-[74px] after:top-[-9px]',
            'after:h-[11px] after:w-3 after:bg-mini-game-ranking-tooltip-bg',
            'after:content-[\'\'] after:[clip-path:polygon(50%_0%,100%_100%,0%_100%)]',
          )}
        >
          <div className="flex flex-col gap-1">
            <p className={bulletItemClass}>
              데일리 랭킹은 매일 자정에 초기화됩니다.
            </p>
            <p className={bulletItemClass}>
              매일 자정 기준 1위에게 포인트가 지급됩니다.
            </p>
            <p className={bulletItemClass}>
              동률인 경우 먼저 달성한 유저에게만 지급됩니다.
            </p>
          </div>
          <button
            onClick={closeTooltip}
            className={cn(
              'flex h-3 w-3 items-center justify-center',
              'cursor-pointer border-none bg-transparent',
            )}
          >
            <LineCloseIcon size={12} color="var(--color-mini-game-ranking-tooltip-icon)" />
          </button>
        </div>
      )}
    </div>
  );
}
